const fieldName = {
  NAME: 'name',
  NOTE: 'note',
  DURATION: 'duration',
};

export default fieldName;
